import { push } from "connected-react-router";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ROUTE_PATH } from "../../app/constants";
import { setMortgageProperty } from "../../redux/slice/primaryAgencyApplicationSlice";
import { Header, Button, Paragraph } from "../../components/RegularComponents";
import TopNavigationBar from "../TopNavigationBar";

const MORTGAGE_APPLICATION_PROPERTY = "addBrokersToBrokerage";
export const AddBrokersToBrokerage = (props) => {
  const dispatch = useDispatch();

  const agentApplications = useSelector((state) => state.additionalApplications?.agentApplications);


  const handleNext = (addBrokersToBrokerAge) => {
    dispatch(
      setMortgageProperty({
        key: MORTGAGE_APPLICATION_PROPERTY,
        value: addBrokersToBrokerAge,
      })
    );

    const nextPath = addBrokersToBrokerAge
      ? ROUTE_PATH.MRA_ASSOCIATE_BEFORE_YOU_START
      : ROUTE_PATH.MRA_PAYMENT_PREVIEW;

    dispatch(
      push({
        pathname: `${ROUTE_PATH.MRA_APP}${nextPath}`,
      })
    );
  };

  let additionalStr = "";
  if(agentApplications?.length > 2) {
    additionalStr = "additional ";
  }

  return (
    <div className="container">
      {/* Title */}
      <TopNavigationBar {...props} />
      <div className="row">
        <div className="col-xs-12 col-lg-11">
          <Header
            id="broker-next-steps-header"
            header={`Add ${additionalStr} Mortgage Brokers to your brokerage`}
          />
          <Paragraph
            id="complete-mortgage-education-text"
            text={[
              `You can apply for ${additionalStr}individual Mortgage Broker and Associate Mortgage Broker licences now, or select <b>'No'</b> to finish your application and continue to payment.  You can apply for more Mortgage Broker and Associate Mortgage Broker licences at any time.`,
              "Do you want to apply for more Mortgage Broker or Associate Mortgage Broker licenses now?",
            ]}
          />
        </div>
      </div>

      {/* Yes/No Answer */}
      <div className="row">
        <div className="col-lg-8">
          <div className="col-xs-2 ">
            <Button
              className={"btn btn-primary btn-lg"}
              buttonType={"regular_primary"}
              text={"Yes"}
              onClick={() => {
                handleNext(true);
              }}
            />
          </div>

          <div className="col-xs-3">
            <Button
              className={"btn btn-primary btn-lg"}
              buttonType={"regular_primary"}
              text={"No"}
              onClick={() => {
                handleNext(false);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
